import { useEffect, useState } from "react";

const STORAGE_KEY = "pegasus.recent_customers";
const MAX_RECENTS = 6;

/**
 * Tracks the most-recently-viewed customer ids in localStorage.
 * Survives page reloads, persists per browser/user. v1 simplicity.
 * Eventually move to a per-user table in Supabase so it follows the
 * user across devices.
 */
export function useRecentCustomers(): {
  recents: string[];
  push: (custno: string) => void;
} {
  const [recents, setRecents] = useState<string[]>(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.filter((x) => typeof x === "string");
      return [];
    } catch {
      return [];
    }
  });

  // Sync to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recents));
    } catch {
      /* ignore quota errors */
    }
  }, [recents]);

  function push(custno: string) {
    setRecents((prev) => {
      const next = [custno, ...prev.filter((c) => c !== custno)];
      return next.slice(0, MAX_RECENTS);
    });
  }

  return { recents, push };
}
